module.exports = __webpack_public_path__ + "static/media/money.6dda1d27.png";